import FilterListIcon from '@mui/icons-material/FilterList'
import CloseIcon from '@mui/icons-material/Close'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import {
    Accordion,
    AccordionItem,
    Button,
    Select,
    SelectItem,
    Slider,
    Switch,
    Tooltip,
} from '@nextui-org/react'
import { Divider, FormControl, FormControlLabel, List } from '@mui/material'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CollectionSelector from '../collectionselector/CollectionSelector'
import Input2 from '../common/util/input/Input'
import { createCategories, createSchemas } from '../helpers/FormatLinks'
import RangeField from './searchfilters/RangeField'

import InputSearch from './searchfilters/InputSearch'
import { buttonSearchCommonStyles, selectStyles } from '../common/styles'
import { useSharedState } from '../waxplorer/Waxplorer'

function DrawerLeft(props) {
    const [isOpen, setIsOpen] = useState(false)
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }

    const { t } = useTranslation('common')
    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null
    const show = props['show']

    const {
        searchSchema,
        searchCategory,
        searchFavorites,
        searchPFPs,
        searchUnlisted,
        searchBacked,
        searchLimit,
        maxPrice,
        minPrice,
        minMint,
        maxMint,
        searchOwner,
        searchTerm,
        attributes,
        searchCollection,
        searchContract,
        searchSearch,
        searchSettings,
        setVars,
        exactSearch,
        orderBy,
        isLoading,
        searchVerified,
        ownerTerm,
        bulk,
        collectionAttributes,
        collectionSchemas,
        clearFilters,
        searchRecentlySold,
        displayCollectionSelector,
        minAverage,
        maxAverage,
        page,
        tradeSearch,
        targetTab,
    } = props

    const [localMinPrice, setLocalMinPrice] = useState(minPrice)
    const [localMaxPrice, setLocalMaxPrice] = useState(maxPrice)

    const [localMinAverage, setLocalMinAverage] = useState(minAverage)
    const [localMaxAverage, setLocalMaxAverage] = useState(maxAverage)

    const [localMinMint, setLocalMinMint] = useState(minMint)
    const [localMaxMint, setLocalMaxMint] = useState(maxMint)

    const [localSearchOwner, setLocalSearchOwner] = useState(searchOwner)

    const clearLocal = () => {
        setLocalSearchOwner('')
        setLocalMinPrice('')
        setLocalMaxPrice('')
        setLocalMinAverage('')
        setLocalMaxAverage('')
        setLocalMinMint('')
        setLocalMaxMint('')
    }

    const ownerFixed =
        searchSettings &&
        searchSettings['owner'] &&
        searchSettings['owner']['fixed']

    const schemaFixed =
        searchSettings &&
        searchSettings['schema'] &&
        searchSettings['schema']['fixed']

    const schemaOptions =
        searchSettings &&
        searchSettings['schema'] &&
        searchSettings['schema']['options'] &&
        searchSettings['schema']['options'][searchCollection]
            ? searchSettings['schema']['options'][searchCollection]
            : null

    const initFilters = () => {
        const startFilters = []

        if (searchSchema || searchCollection) {
            startFilters.push('schema')
        }
        if (searchFavorites) {
            startFilters.push('favorites')
        }
        if (maxPrice || minPrice) {
            startFilters.push('price')
        }
        if (maxMint || minMint) {
            startFilters.push('mint')
        }
        if (searchOwner) {
            startFilters.push('owner')
        }
        if (searchTerm) {
            startFilters.push('name')
        }

        return startFilters
    }

    const filters = initFilters()

    useEffect(() => {}, [filters.length])

    const isCollectionSales = searchSearch === 'collection_sales'

    const isPackSearch =
        searchSearch === 'ft_packs' || searchSearch === 'my_ft_packs'

    let searchDropDownOptions = [
        { value: 'listings', label: 'Standard' },
        { value: 'my_sales', label: 'My Listings' },
        { value: 'cheapest', label: t('search.cheapest') },
        { value: 'below_average', label: t('search.below_average') },
        { value: 'below_last_sold', label: t('search.below_last_sold') },
        { value: 'sales', label: t('search.trades') },
        { value: 'assets', label: t('search.assets') },
        { value: 'burned', label: t('search.burned') },
        { value: 'staked', label: t('asset.staked') },
        { value: 'bundles', label: t('search.bundles') },
    ]

    if (searchCollection && searchCollection === 'kogsofficial')
        searchDropDownOptions.push({ value: 'tubed', label: t('asset.tubed') })

    let recentDropDownOptions = [
        { value: '', label: 'None' },
        { value: 'hour', label: 'The Last hour' },
        { value: 'day', label: 'The Last Day' },
        { value: 'week', label: 'The Last Week' },
        { value: 'month', label: 'The Last Month' },
    ]

    if (isCollectionSales) {
        searchDropDownOptions = null
    }

    if (bulk)
        searchDropDownOptions = [
            { value: 'bulk_sell', label: t('search.bulk_sell') },
            { value: 'bulk_auction', label: t('popups.auction') },
            { value: 'bulk_burn', label: t('search.bulk_burn') },
            { value: 'bulk_unstake', label: t('asset.unstake') },
            { value: 'bulk_edit', label: t('search.bulk_edit') },
            {
                value: 'bulk_sell_duplicates',
                label: t('search.bulk_sell_duplicates'),
            },
            {
                value: 'bulk_sell_highest_duplicates',
                label: t('search.bulk_sell_highest_duplicates'),
            },
            { value: 'bulk_cancel', label: t('asset.cancel') },
            { value: 'bulk_buy', label: t('asset.buy') },
            { value: 'bulk_transfer', label: t('search.bulk_transfer') },
            {
                value: 'bulk_transfer_duplicates',
                label: t('search.bulk_transfer_duplicates'),
            },
            {
                value: 'bulk_transfer_lowest_mints',
                label: t('search.bulk_transfer_lowest_mints'),
            },
            { value: 'bulk_distribute', label: t('search.bulk_distribute') },
            { value: 'bulk_bundle', label: t('search.bundle') },
            {
                value: 'bulk_bundle_highest_mints',
                label: t('search.bundle_highest_mints'),
            },
            {
                value: 'bulk_bundle_lowest_mints',
                label: t('search.bundle_lowest_mints'),
            },
            {
                value: 'bulk_bundle_highest_duplicates',
                label: t('search.bundle_highest_duplicates'),
            },
        ]

    if (targetTab === 'pfp') {
        searchDropDownOptions = [
            {
                value: 'pfps',
                label: t('search.pfp_ranking'),
            },
            { value: 'sales', label: t('search.sales') },
        ]
    }

    if (targetTab === 'inventory' && userName) {
        searchDropDownOptions = [
            {
                value: 'assets',
                label:
                    userName === searchOwner
                        ? t('search.my_assets')
                        : t('search.assets'),
            },
            { value: 'duplicates', label: t('search.duplicates') },
            {
                value: 'highest_duplicates',
                label: t('search.highest_duplicates'),
            },
            { value: 'my_packs', label: t('search.my_packs') },
            { value: 'lowest_mints', label: t('search.lowest_mints') },
            { value: 'highest_mints', label: t('search.highest_mints') },
            { value: 'staked', label: t('asset.staked') },
        ]
        if (searchCollection && searchCollection === 'kogsofficial')
            searchDropDownOptions.push({
                value: 'tubed',
                label: t('asset.tubed'),
            })
    }

    const contractDropdownOptions = [
        { value: 'all', label: 'All' },
        { value: 's.rplanet', label: 'RPlanet' },
        { value: 'waxdaofarmer', label: 'WAXDao' },
    ]

    const getContractOption = (contract) => {
        const option = Math.max(
            contractDropdownOptions.map((item) => item.value).indexOf(contract),
            0,
        )

        return contractDropdownOptions[option]
    }

    const defaultContractOption = getContractOption(searchContract)

    const limitDropdownOptions = [
        { value: 50, label: 50 },
        { value: 30, label: 30 },
        { value: 45, label: 45 },
        { value: 120, label: 120 },
        { value: 180, label: 180 },
        { value: 240, label: 240 },
        { value: 300, label: 300 },
        { value: 360, label: 360 },
    ]

    const getLimitOption = (limit) => {
        const option = Math.max(
            limitDropdownOptions
                .map((item) => item.value)
                .indexOf(parseInt(limit)),
            0,
        )

        return limitDropdownOptions[option]
    }

    const defaultLimitOption = getLimitOption(searchLimit)

    if (targetTab === 'summaries' && userName) searchDropDownOptions = null
    if (targetTab === 'transfers') searchDropDownOptions = null
    else if (targetTab === 'buyoffers') {
        if (page === 'inventory') searchDropDownOptions = null
        else
            searchDropDownOptions = [
                { value: 'buyoffers', label: 'All' },
                { value: 'buyoffers_owned', label: 'Owned' },
                { value: 'best_buyoffers', label: 'Best Offers' },
                { value: 'best_buyoffers_owned', label: 'Best Owned' },
            ]
    } else if (targetTab === 'assets') {
        searchDropDownOptions = [
            { value: 'assets', label: t('search.all_assets') },
            { value: 'burned', label: t('search.burned') },
            { value: 'staked', label: t('asset.staked') },
        ]
        if (searchCollection && searchCollection === 'kogsofficial')
            searchDropDownOptions.push({
                value: 'tubed',
                label: t('asset.tubed'),
            })
    } else if (targetTab === 'templates') {
        searchDropDownOptions = null
    } else if (tradeSearch) searchDropDownOptions = null
    else if (targetTab === 'bundles') searchDropDownOptions = null
    else if (targetTab === 'listings' || targetTab === 'open_market') {
        searchDropDownOptions = [
            { value: 'sales', label: 'Standard' },
            { value: 'cheapest', label: t('search.cheapest_sales') },
            {
                value: 'owned_lower_mints',
                label: t('search.owned_lower_mints'),
            },
        ]
        if (userName) {
            searchDropDownOptions.push({
                value: 'cheapest_missing',
                label: t('search.cheapest_missing'),
            })
            searchDropDownOptions.push({
                value: 'missing',
                label: 'Missing Listings',
            })
        }
        searchDropDownOptions.push({
            value: 'below_average',
            label: t('search.below_average'),
        })
        searchDropDownOptions.push({
            value: 'below_last_sold',
            label: t('search.below_last_sold'),
        })
        if (
            ['*', 'farmersworld', 'spacecraftx', 'bcbrawlers'].includes(
                searchCollection,
            )
        ) {
            searchDropDownOptions.push({
                value: 'below_crafting_cost',
                label: t('search.below_crafting_cost'),
            })
        }
    } else if (targetTab === 'auctions')
        if (
            searchSettings &&
            searchSettings['owner'] &&
            searchSettings['owner']['fixed']
        ) {
            searchDropDownOptions = []
        } else {
            searchDropDownOptions = [
                { value: 'auctions', label: 'Standard' },
                { value: 'my_auctions', label: t('search.my_auctions') },
            ]
        }
    else if (targetTab === 'packs')
        searchDropDownOptions = [{ value: 'packs', label: t('overview.packs') }]
    else if (searchSearch === 'sales') searchDropDownOptions = null

    if (
        searchSettings &&
        searchSettings['search_type'] &&
        searchSettings['search_type']['fixed']
    ) {
        searchDropDownOptions = null
    }

    const schemaDropDownOptions =
        collectionSchemas && !schemaFixed
            ? createSchemas(
                  collectionSchemas.filter(
                      (item) =>
                          item['schema'] !== null &&
                          searchCollection === item['collection'],
                  ),
                  searchSearch !== 'collection_sales' && !schemaOptions,
                  schemaOptions,
              )
            : null

    const categoryDropDownOptions = createCategories(t)

    const filterDropDownOptions = []

    filterDropDownOptions.push({ value: '', label: 'Add Filter' })

    if (schemaDropDownOptions && !filters.includes('schema')) {
        filterDropDownOptions.push({
            value: 'schema',
            label: t('asset.schema'),
        })
    }

    if (!filters.includes('owner')) {
        filterDropDownOptions.push({ value: 'owner', label: ownerTerm })
    }

    if (!filters.includes('name')) {
        filterDropDownOptions.push({ value: 'name', label: t('search.name') })
    }

    if (!filters.includes('asset_id')) {
        filterDropDownOptions.push({ value: 'asset_id', label: 'Asset ID' })
    }

    if (!filters.includes('template_id')) {
        filterDropDownOptions.push({
            value: 'template_id',
            label: 'Template ID',
        })
    }

    if (!filters.includes('mint')) {
        filterDropDownOptions.push({ value: 'mint', label: t('asset.mint') })
    }

    if (!filters.includes('price')) {
        filterDropDownOptions.push({ value: 'price', label: t('asset.price') })
    }

    if (!filters.includes('favorites')) {
        filterDropDownOptions.push({
            value: 'favorites',
            label: t('search.favorites'),
        })
    }

    const applyPriceRange = (min, max) => {
        setVars({
            min_price: min,
            max_price: max,
            min_average: localMinAverage,
            max_average: localMaxAverage,
            min_mint: localMinMint,
            max_mint: localMaxMint,
            owner: localSearchOwner,
            offset: 0,
        })
    }

    const applyAverageRange = (min, max) => {
        setVars({
            min_price: localMinPrice,
            max_price: localMaxPrice,
            min_average: min,
            max_average: max,
            min_mint: localMinMint,
            max_mint: localMaxMint,
            owner: localSearchOwner,
            offset: 0,
        })
    }

    const applyMintRange = (min, max) => {
        setVars({
            min_price: localMinPrice,
            max_price: localMaxPrice,
            min_mint: min,
            max_mint: max,
            min_average: localMinAverage,
            max_average: localMaxAverage,
            owner: localSearchOwner,
            offset: 0,
        })
    }

    const applyOwnerChange = (val) => {
        setVars({
            min_price: localMinPrice,
            max_price: localMaxPrice,
            min_mint: localMinMint,
            max_mint: localMaxMint,
            min_average: localMinAverage,
            max_average: localMaxAverage,
            owner: val,
            offset: 0,
        })
    }

    const handleOwnerChange = (e) => {
        setLocalSearchOwner(e.target.value)
    }

    const handleUserChange = () => {
        if (userName) {
            setVars({
                min_price: localMinPrice,
                max_price: localMaxPrice,
                min_mint: localMinMint,
                max_mint: localMaxMint,
                min_average: localMinAverage,
                max_average: localMaxAverage,
                owner: userName,
                offset: 0,
            })
            setLocalSearchOwner(userName)
        }
    }

    const handleOwnerClear = () => {
        setVars({
            min_price: localMinPrice,
            max_price: localMaxPrice,
            min_mint: localMinMint,
            max_mint: localMaxMint,
            min_average: localMinAverage,
            max_average: localMaxAverage,
            owner: '',
            offset: 0,
        })
        setLocalSearchOwner('')
    }

    const onSelectCategory = (e) => {
        const value = parseInt(e.target.value) === 0 ? '' : e.target.value
        setVars({
            category: value,
            collection: '',
            offset: 0,
        })
    }

    const onSelectSchema = (e) => {
        setVars({
            schema: e.target.value,
            offset: 0,
        })
    }

    const getOrder = (search, def) => {
        let order = def

        if (
            ['assets', 'duplicates', 'highest_duplicates', 'packs'].includes(
                search,
            )
        ) {
            order = 'date_desc'
        } else if (search === 'sales') {
            order = 'date_desc'
        } else if (search === 'templates') {
            order = 'template_id_desc'
        } else if (
            ['missing', 'cheapest', 'cheapest_missing'].includes(search)
        ) {
            order = 'price_asc'
        } else if ('sales' === search) {
            order = 'date_desc'
        } else if (search === 'bundles') {
            order = 'date_desc'
        } else if (
            [
                'lowest_mints',
                'highest_mints',
                'bulk_transfer_lowest_mints',
            ].includes(search)
        ) {
            order = 'mint_asc'
        } else if (
            [
                'bulk_transfer',
                'bulk_swap_atomic',
                'bulk_swap_simple',
                'bulk_distribute',
                'bulk_cancel',
                'bulk_transfer_duplicates',
                'bulk_stake',
                'bulk_unstake',
                'bulk_sell',
                'bulk_auction',
                'bulk_multi_sell',
                'bulk_burn',
                'bulk_sell_duplicates',
                'bulk_sell_duplicates',
                'bulk_bundle',
                'bulk_bundle_lowest_mints',
                'bulk_bundle_highest_mints',
                'bulk_bundle_highest_duplicates',
                'bulk_sell_highest_duplicates',
            ].includes(search)
        ) {
            order = 'date_desc'
        } else if (search === 'bulk_buy') {
            order = 'price_asc'
        }

        return order
    }

    const onSelectSearch = (e) => {
        let order = getOrder(e.target.value, orderBy)

        let newOwner = searchOwner
        if (e.target.value === 'bulk_buy') {
            newOwner = ''
        } else if (e.target.value === 'my_auctions') {
            newOwner = userName
        }

        setVars({
            search: e.target.value,
            order: order,
            owner: newOwner,
            offset: 0,
            backed:
                searchBacked &&
                !['collection_sales', 'summaries', 'sales'].includes(
                    e.target.value,
                ),
        })
    }

    const onSelectContract = (e) => {
        setVars({
            contract: e.target.value,
            offset: 0,
        })
    }

    const onSelectCollection = (e) => {
        let schema = true

        let collection = e
        if (e === searchCollection) collection = '*'

        if (collectionSchemas) {
            schema = collectionSchemas
                .filter((item) => item['collection'] === e)
                .map((item) => item.schema)
                .includes(searchSchema)
        }

        setVars({
            collection: collection,
            schema: schema ? searchSchema : '',
            category: null,
            attributes: '',
            offset: 0,
        })
    }

    const onCheckVerified = (e) => {
        setVars({
            verified: e,
            offset: 0,
        })
    }

    const onCheckFavorites = () => {
        setVars({
            favorites: !searchFavorites,
            offset: 0,
        })
    }

    const onCheckPFPs = () => {
        setVars({
            pfps_only: !searchPFPs,
            offset: 0,
        })
    }

    const onCheckUnlisted = () => {
        setVars({
            unlisted_only: !searchUnlisted,
            offset: 0,
        })
    }

    const onSelectLimit = (e) => {
        setVars({
            limit: e.target.value,
            offset: 0,
        })
    }

    const onCheckBacked = () => {
        setVars({
            backed: !searchBacked,
            offset: 0,
        })
    }

    const onSelectRecentlySold = (e) => {
        setVars({
            recent: e.target.value,
            offset: 0,
        })
    }

    const getSearchOption = (search) => {
        return searchDropDownOptions.map((item) => item.value).indexOf(search)
    }

    const defaultSearchOption = searchDropDownOptions
        ? searchDropDownOptions[getSearchOption(searchSearch)]
        : null

    const initToggleItems = () => {
        const map = new Map()
        // Open Collections per defautlt
        map.set(
            ['assets', 'inventory'].includes(searchSearch)
                ? 'Asset Type'
                : searchSearch.includes('bulk')
                ? 'Bulk Operation'
                : searchSearch === 'auctions'
                ? 'Auction Type'
                : targetTab === 'pfp'
                ? 'PFP Search Type'
                : 'Market Filter',
            true,
        )
        map.set(t('navigation.collections'), true)
        map.set(t('search.schema'), true)
        map.set(t('search.category'), searchCategory)
        map.set(t('search.last_sold_within'), searchRecentlySold)
        map.set(ownerTerm, searchOwner)
        map.set('Price', minPrice || maxPrice)
        map.set('Average', minAverage || maxAverage)
        map.set('Mint', minMint || maxMint)
        map.set('Backed Tokens', searchBacked)
        return map
    }

    const [toggleItem, setToggleItem] = useState(true)
    useEffect(() => {
        setToggleItem(initToggleItems())
    }, [show])

    const onSelectAttribute = async (value, attr) => {
        const attrBreakDown = {}

        const oldAttrStr = unescape(attributes)

        for (const attribute of oldAttrStr.split(',')) {
            if (attribute.includes(':')) {
                attrBreakDown[attribute.split(':')[0]] = escape(
                    attribute.split(':')[1],
                )
            }
        }

        if (value) {
            if (typeof value === 'object') {
                attrBreakDown[attr] = escape(value[0] + '-' + value[1])
            } else {
                attrBreakDown[attr] = escape(value)
            }
        } else {
            delete attrBreakDown[attr]
        }

        let attrStr = ''
        for (const key of Object.keys(attrBreakDown)) {
            attrStr += key + ':' + attrBreakDown[key] + ','
        }

        if (attrStr.length > 0) {
            attrStr = attrStr.substr(0, attrStr.length - 1)
        }

        setVars({
            attributes: attrStr,
            offset: 0,
        })
    }

    const getAttributeDefaultOption = (attr) => {
        if (attributes.includes(attr)) {
            const attrBreakDown = {}

            const oldAttrStr = unescape(attributes)

            for (const attribute of oldAttrStr.split(',')) {
                if (attribute.includes(':')) {
                    attrBreakDown[attribute.split(':')[0]] = escape(
                        attribute.split(':')[1],
                    )
                }
            }

            if (Object.keys(attrBreakDown).includes(attr)) {
                return unescape(attrBreakDown[attr])
            } else {
                return null
            }
        }

        return null
    }

    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [screenWidth])

    const renderStringSelector = (attr, attribute, index) => {
        return (
            <Select
                onChange={(e) => onSelectAttribute(e.target.value, attr)}
                value={getAttributeDefaultOption(attr)}
                selectedKeys={[getAttributeDefaultOption(attr)]}
                id={`DropdownFieldAttr${index}`}
                label={attr}
                disabled={
                    searchSearch === 'bulk_burn' ||
                    !schemaDropDownOptions ||
                    isLoading ||
                    !searchCollection
                }
                variant="faded"
                classNames={{
                    ...selectStyles,
                }}
            >
                {attribute.values.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                        {option.value || ' - '}
                    </SelectItem>
                ))}
            </Select>
        )
    }

    const renderSlider = (attr, attribute, index) => {
        const defaultValue = getAttributeDefaultOption(attr)

        return (
            <div>
                <Slider
                    id={`range-${attr}-${index}`}
                    name={`range-${attr}-${index}`}
                    minValue={attribute.minValue}
                    maxValue={attribute.maxValue}
                    getValue={() =>
                        `${attribute.minValue} - ${attribute.maxValue}`
                    }
                    defaultValue={[attribute.minValue, attribute.maxValue]}
                    label={attr}
                    onChangeEnd={(e) => {
                        if (
                            e[0] === attribute.minValue &&
                            e[1] === attribute.maxValue
                        ) {
                            onSelectAttribute(null, attr)
                        } else {
                            onSelectAttribute(e, attr)
                        }
                    }}
                    showTooltip
                    aria-label={`${attr} ${index} range`}
                />
            </div>
        )
    }

    const filterButton = (
        <Button
            size="sm"
            className={cn(
                '!w-[56px] h-[56px] border-2 mr-2',
                buttonSearchCommonStyles,
            )}
            variant="bordered"
            onClick={toggleDrawer}
        >
            <FilterListIcon />
        </Button>
    )
    return (
        <>
            <Tooltip
                showArrow={true}
                key="right"
                placement="right"
                content="Show Filters"
                color="foreground"
                delay={0}
                closeDelay={0}
            >
                {filterButton}
            </Tooltip>

            <Drawer
                lockBackgroundScroll={true}
                open={isOpen}
                onClose={toggleDrawer}
                direction="left"
                className="min-w-[330px] dark:!bg-zinc-900 bg-white p-4 overflow-y-auto !h-[calc(100vh-88px)]"
            >
                <div className="flex items-center justify-between">
                    <p className="text-lg font-semibold text-black dark:text-white">
                        Filters
                    </p>

                    <Tooltip
                        showArrow={true}
                        key="right"
                        placement="right"
                        content="Close Filters"
                        color="foreground"
                        delay={0}
                        closeDelay={0}
                    >
                        <Button
                            isIconOnly
                            aria-label="Like"
                            onClick={toggleDrawer}
                            className={cn(
                                'h-[48px] w-[48px] border-2',
                                buttonSearchCommonStyles,
                            )}
                        >
                            <CloseIcon />
                        </Button>
                    </Tooltip>
                </div>

                <div className={'w-full'}>
                    <List dense>
                        <Divider />
                        <div className="mb-4" />
                        {searchDropDownOptions && (
                            /* Market Filter */
                            <div className="mx-1 my-3">
                                <Select
                                    scrollShadowProps={{ hideScrollBar: false }}
                                    variant="faded"
                                    label={
                                        ['assets', 'inventory'].includes(
                                            searchSearch,
                                        )
                                            ? 'Asset Type'
                                            : searchSearch.includes('bulk')
                                            ? 'Bulk Operation'
                                            : searchSearch === 'auctions'
                                            ? 'Auction Type'
                                            : targetTab === 'pfp'
                                            ? 'PFP Search Type'
                                            : 'Market Filter'
                                    }
                                    className="w-full"
                                    classNames={{
                                        ...selectStyles,
                                    }}
                                    disabled={
                                        (searchSettings &&
                                            searchSettings['search_type'] &&
                                            searchSettings['search_type'][
                                                'fixed'
                                            ]) ||
                                        isLoading
                                            ? 'disabled'
                                            : ''
                                    }
                                    onChange={onSelectSearch}
                                    value={
                                        defaultSearchOption &&
                                        defaultSearchOption.value
                                            ? defaultSearchOption.value
                                            : ''
                                    }
                                >
                                    {searchDropDownOptions.map((option) => (
                                        <SelectItem
                                            key={option.value}
                                            value={option.value}
                                        >
                                            {option.label}
                                        </SelectItem>
                                    ))}
                                </Select>
                            </div>
                        )}
                        {displayCollectionSelector && (
                            <Accordion
                                isCompact={false}
                                disableAnimation={false}
                                disableIndicatorAnimation={false}
                                hideIndicator={false}
                                isDisabled={false}
                                defaultExpandedKeys={['CollectionItem']}
                            >
                                <AccordionItem
                                    classNames={{
                                        title: 'dark:dark:text-white !text-base !md:text-xs !xl:text-base font-semibold',
                                    }}
                                    key={'CollectionItem'}
                                    title={t('navigation.collections')}
                                    toggleItem={toggleItem}
                                    setToggleItem={setToggleItem}
                                >
                                    <CollectionSelector
                                        searchCollection={searchCollection}
                                        searchVerified={searchVerified}
                                        selectCollection={onSelectCollection}
                                        onCheckVerified={onCheckVerified}
                                        searchSearch={searchSearch}
                                        searchItem={true}
                                        owner={
                                            bulk &&
                                            userName &&
                                            searchSearch !== 'bulk_buy'
                                                ? userName
                                                : searchOwner
                                        }
                                        searchType={searchSearch}
                                        searchPFPs={searchPFPs}
                                    />
                                </AccordionItem>
                            </Accordion>
                        )}
                        {schemaDropDownOptions && (
                            <div className="mx-1 my-3">
                                <Select
                                    scrollShadowProps={{ hideScrollBar: false }}
                                    id="DropdownField3"
                                    variant="faded"
                                    label={t('search.schema')}
                                    className="w-full"
                                    classNames={{
                                        ...selectStyles,
                                    }}
                                    onChange={onSelectSchema}
                                    disabled={
                                        searchSearch === 'bulk_burn' ||
                                        !schemaDropDownOptions ||
                                        isLoading ||
                                        !searchCollection
                                    }
                                >
                                    {schemaDropDownOptions.map((option) => (
                                        <SelectItem
                                            value={option.value}
                                            key={option.value}
                                        >
                                            {option.label}
                                        </SelectItem>
                                    ))}
                                </Select>
                            </div>
                        )}
                        {searchSchema &&
                        searchSchema !== '*' &&
                        collectionAttributes &&
                        Object.keys(collectionAttributes).length > 0 ? (
                            <div className="space-y-4 mt-4">
                                <Divider />
                                <div className="mb-4" />
                                <p className="text-base font-semibold text-black dark:text-white ml-2 mt-4">
                                    Attributes
                                </p>

                                {Object.keys(collectionAttributes).map(
                                    (attr, index) => {
                                        const attribute =
                                            collectionAttributes[attr]

                                        return (
                                            <div
                                                key={index}
                                                className="mx-1 my-3"
                                            >
                                                {attribute.type === 'string' ? (
                                                    renderStringSelector(
                                                        attr,
                                                        attribute,
                                                        index,
                                                    )
                                                ) : (attribute.type ===
                                                      'integer' &&
                                                      attribute.minValue ===
                                                          0 &&
                                                      attribute.maxValue ===
                                                          1) ||
                                                  attribute.type ===
                                                      'boolean' ? (
                                                    <div>
                                                        <Switch
                                                            checked={
                                                                getAttributeDefaultOption(
                                                                    attr,
                                                                ) === '1'
                                                            }
                                                            onChange={(e) =>
                                                                onSelectAttribute(
                                                                    e.target
                                                                        .checked
                                                                        ? 1
                                                                        : 0,
                                                                    attr,
                                                                )
                                                            }
                                                            id={`switch-${attr}`}
                                                            aria-label={`Toggle ${attr}`}
                                                        >
                                                            {attr}
                                                        </Switch>
                                                    </div>
                                                ) : attribute.type ===
                                                      'integer' &&
                                                  attribute.minValue !==
                                                      attribute.maxValue ? (
                                                    renderSlider(
                                                        attr,
                                                        attribute,
                                                        index,
                                                    )
                                                ) : null}
                                            </div>
                                        )
                                    },
                                )}
                            </div>
                        ) : (
                            ''
                        )}

                        {displayCollectionSelector &&
                            categoryDropDownOptions &&
                            (!searchCollection || searchCollection === '*') && (
                                <div className="mx-1 my-3">
                                    <Select
                                        scrollShadowProps={{
                                            hideScrollBar: false,
                                        }}
                                        id="DropdownField14"
                                        variant="faded"
                                        disabled={
                                            !categoryDropDownOptions ||
                                            isLoading
                                        }
                                        label={t('search.category')}
                                        className="w-full"
                                        classNames={{
                                            ...selectStyles,
                                        }}
                                        onChange={onSelectCategory}
                                    >
                                        <SelectItem value={0} key={0}>
                                            All
                                        </SelectItem>
                                        {categoryDropDownOptions.map(
                                            (option) => (
                                                <SelectItem
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </SelectItem>
                                            ),
                                        )}
                                    </Select>
                                </div>
                            )}
                        {searchSearch !== 'collection_sales' && (
                            <div className="mx-1 my-3">
                                <Select
                                    scrollShadowProps={{ hideScrollBar: false }}
                                    id="DropdownField9"
                                    variant="faded"
                                    label={t('search.last_sold_within')}
                                    className="w-full"
                                    classNames={{
                                        ...selectStyles,
                                    }}
                                    onChange={onSelectRecentlySold}
                                    disabled={isLoading}
                                >
                                    {recentDropDownOptions.map((option) => (
                                        <SelectItem
                                            key={option.value}
                                            value={option.value}
                                        >
                                            {option.label}
                                        </SelectItem>
                                    ))}
                                </Select>
                            </div>
                        )}
                        {['staked', 'bulk_unstake'].includes(searchSearch) && (
                            /* Market Filter */
                            <div className="mx-1 my-3">
                                <FormControl fullWidth size="small">
                                    {/*    <InputLabel
                                        className={
                                            'text-base md:text-xs xl:text-base'
                                        }
                                    >
                                        Staking Contract
                                    </InputLabel> */}
                                    <Select
                                        onChange={onSelectContract}
                                        value={
                                            defaultContractOption &&
                                            defaultContractOption.value
                                                ? defaultContractOption.value
                                                : ''
                                        }
                                        id="DropdownField22"
                                        label={'Staking Contract'}
                                        disabled={isLoading ? 'disabled' : ''}
                                        variant="faded"
                                        classNames={{
                                            ...selectStyles,
                                        }}
                                    >
                                        {contractDropdownOptions.map(
                                            (option) => (
                                                <SelectItem
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </SelectItem>
                                            ),
                                        )}
                                    </Select>
                                </FormControl>
                            </div>
                        )}
                        {searchSearch.includes('bulk_') && (
                            /* Limit Filter */
                            <div className="mx-1 my-3">
                                <FormControl fullWidth size="small">
                                    {/*   <InputLabel
                                        className={
                                            'text-base md:text-xs xl:text-base'
                                        }
                                    >
                                        {t('search.number_of_results')}
                                    </InputLabel> */}
                                    <Select
                                        variant="faded"
                                        onChange={onSelectLimit}
                                        value={
                                            defaultLimitOption &&
                                            defaultLimitOption.value
                                                ? defaultLimitOption.value
                                                : ''
                                        }
                                        id="DropdownField22"
                                        label={t('search.number_of_results')}
                                        disabled={isLoading ? 'disabled' : ''}
                                        classNames={{
                                            ...selectStyles,
                                        }}
                                    >
                                        {limitDropdownOptions.map((option) => (
                                            <SelectItem
                                                key={option.value}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </SelectItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        )}
                        {!ownerFixed &&
                        ![
                            'summaries',
                            'collection_sales',
                            'templates',
                        ].includes(searchSearch) ? (
                            <div className="mx-1 my-3">
                                <InputSearch
                                    applyTerm={applyOwnerChange}
                                    handleTermChange={handleOwnerChange}
                                    handleOwnerClear={handleOwnerClear}
                                    value={
                                        localSearchOwner ? localSearchOwner : ''
                                    }
                                    disabled={
                                        isPackSearch ||
                                        isLoading ||
                                        (searchSettings &&
                                            searchSettings['owner'] &&
                                            searchSettings['owner']['fixed'])
                                    }
                                    userChangeEnabled={
                                        userName &&
                                        userName !== searchOwner &&
                                        !(isPackSearch || isLoading) &&
                                        !(
                                            searchSettings['owner'] &&
                                            searchSettings['owner']['fixed']
                                        )
                                    }
                                    handleUserChange={handleUserChange}
                                    ownerTerm={ownerTerm}
                                />
                            </div>
                        ) : (
                            ''
                        )}
                        {searchSearch !== 'collection_sales' &&
                            searchSearch !== 'summaries' &&
                            [
                                'sales',
                                'missing',
                                'below_last_sold',
                                'owned_lower_mints',
                                'cheapest_missing',
                                'bundles',
                                'listings',
                                'cheapest',
                                'packs',
                                'ft_packs',
                                'bulk_buy',
                            ].includes(searchSearch) && (
                                <RangeField
                                    disabled={isLoading ? 'disabled' : ''}
                                    minVal={localMinPrice}
                                    maxVal={localMaxPrice}
                                    setMin={setLocalMinPrice}
                                    setMax={setLocalMaxPrice}
                                    applyRange={applyPriceRange}
                                    useFloat={true}
                                    name={t('search.price')}
                                />
                            )}
                        {searchSearch !== 'collection_sales' &&
                            searchSearch !== 'summaries' &&
                            false && (
                                <RangeField
                                    disabled={isLoading ? 'disabled' : ''}
                                    minVal={localMinAverage}
                                    maxVal={localMaxAverage}
                                    setMin={setLocalMinAverage}
                                    setMax={setLocalMaxAverage}
                                    applyRange={applyAverageRange}
                                    useFloat={true}
                                    name={t('search.median')}
                                />
                            )}
                        {searchSearch !== 'collection_sales' &&
                            searchSearch !== 'summaries' &&
                            ![
                                'bundles',
                                'ft_packs',
                                'collection_sales',
                                'templates',
                            ].includes(searchSearch) && (
                                <RangeField
                                    disabled={
                                        isPackSearch || isLoading
                                            ? 'disabled'
                                            : ''
                                    }
                                    minVal={localMinMint}
                                    maxVal={localMaxMint}
                                    applyRange={applyMintRange}
                                    setMin={setLocalMinMint}
                                    setMax={setLocalMaxMint}
                                    useFloat={false}
                                    name={t('search.mint')}
                                />
                            )}
                        {searchSearch !== 'collection_sales' &&
                            searchSearch !== 'summaries' &&
                            false && (
                                <div
                                    className={{
                                        hidden: !userName || isPackSearch,
                                    }}
                                >
                                    <div className={cn('flex justify-center')}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={searchFavorites}
                                                    onChange={onCheckFavorites}
                                                />
                                            }
                                            label="Filter to Favorites"
                                            labelPlacement="start"
                                        />
                                    </div>
                                </div>
                            )}

                        <div
                            className={cn('mt-6', {
                                hidden: !userName || isPackSearch,
                            })}
                        >
                            <div
                                className={cn(
                                    'flex justify-center overflow-x-hidden',
                                )}
                            >
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={searchPFPs}
                                            onChange={onCheckPFPs}
                                        />
                                    }
                                    label="Only PFPs with Traits"
                                    labelPlacement="top"
                                />
                            </div>
                        </div>
                        <div className={cn('block mt-8')}>
                            <Input2
                                name="ExactSearch"
                                type="hidden"
                                value={
                                    exactSearch === 'true' ||
                                    exactSearch === true
                                }
                                disabled={
                                    isPackSearch || isLoading ? 'disabled' : ''
                                }
                            />
                            <div className="flex justify-center px-2 font-bold">
                                <Button
                                    variant="bordered"
                                    color="warning"
                                    className="w-full font-semibold"
                                    radius="sm"
                                    fullWidth={false}
                                    onClick={() => {
                                        clearFilters()
                                        clearLocal()
                                        setToggleItem(initToggleItems())
                                    }}
                                >
                                    Clear
                                </Button>
                            </div>
                        </div>
                    </List>
                </div>
            </Drawer>
        </>
    )
}

export default DrawerLeft
